import IndividualTypeList from "./IndividualTypeList";

const BrandDeadlines = () => {
  return <IndividualTypeList type={"brandDeadlines"} />;
};

export default BrandDeadlines;
